import React, { Component} from 'react';
import {connect} from 'react-redux';

class Checkpoint extends Component {
	constructor(props){
		super(props);
	}
	componentDidMount(){
		const { dispatch } = this.props;
	}
	render() {
		return (
			<div className = "root">
                <div className = "banner">Checkpoint</div>
			</div>
		);
	}
}

  
export default Checkpoint;